import {Component} from '@angular/core';
import '../../node_modules/ceotr-web-common/helpers/extensions.js';
import * as appGlobals from 'globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ng-app';

  public isMobile = window.innerWidth < 576;

  constructor() {
    appGlobals.isMobile = this.isMobile;
  }
}
